// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","contestDescriptionHeader":"_2ca4xD9IeS3yePjrsKk0bO","contestDescriptionSubHeader":"_3FfiGj6xcljysO_DNCGyAs","headerWithButton":"_2EAvMGynvrKCbgqt8v84Mo"};